import React from 'react';
import { Modal, Transfer, Spin } from "antd";

function RolesModal({ onCancel, visible, roles, targets, onChange, loading }) {
    return (<Modal visible={visible} title="Roles de usuario" onCancel={onCancel} footer={null} >
        <Spin tip="Loading..." spinning={loading}>
            <Transfer listStyle={{ width: 300, height: 300, }}
                dataSource={roles} 
                targetKeys={targets}
                onChange={onChange}
                showSelectAll={false}
                titles={['Roles', 'Asignados']}
                render={(i) => i.title} />
        </Spin>
    </Modal>);
}

export default RolesModal;


// WEBPACK FOOTER //
// ./src/components/RolesModal.jsx